import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { array, number, object } from 'prop-types';
import { startSetOfferExtraGroups, startSetOffer } from '../../actions/offers';
import Card from '../Card/Card';
import PromoGroup from '../Promo/PromoGroup';
import PromoGroupFilter from '../Promo/PromoGroupFilter';

class OfferPromo extends Component {
  static propTypes = {
    offerId: number.isRequired,
    offer: object.isRequired,
    groups: array.isRequired,
  };

  static defaultProps = {
    groups: [],
    format: 'img',
    offer: {},
  };

  componentDidMount() {
    const { offerId } = this.props;
    this.props.startSetOffer(offerId).then(() => this.props.startSetOfferExtraGroups(offerId));
  }

  state = {
    filter: {
      type: 'all',
      size: null,
      collection: null,
    },
  };

  changeFormat = format => {
    this.setState(() => ({ format }));
  };

  getTypes = () => [
    { type: 'all', name: <FormattedMessage id="offer.promo.all-formats" defaultMessage="All formats"/> },
    { type: 'img', name: 'JPEG/GIF' },
    { type: 'flash', name: 'Flash' },
  ];

  getBannerFormat = (groups, filter) =>
    groups.reduce((collections, collection) => {
      if (filter.collection && filter.collection !== collection.id) {
        return collections;
      }

      const banners = collection.banners.reduce((sorted, banner) => {
        const size = `${banner.width}x${banner.height}`;

        if (filter.type && filter.type !== 'all' && filter.type !== banner.format) {
          return sorted;
        }

        if (filter.size && filter.size !== size) {
          return sorted;
        }

        (sorted[size] = sorted[size] || { size, imgs: [] }).imgs.push(banner);

        return sorted;
      }, {});

      return [...collections, ...Object.values(banners)];
    }, []);

  getFilterList = groups =>
    groups.reduce(
      (list, group, index) => {
        const tmpSizes = [];

        list.names[index] = { name: group.name, id: group.id };

        list.sizes = group.sizes.map(size => {
          if (!tmpSizes.includes(size)) {
            tmpSizes.push(size);

            return { size: size, key: size };
          }
        });

        return list;
      },
      {
        names: [],
        sizes: [],
      },
    );

  handleFilterChange = filter => {
    this.setState(() => ({ filter }));
  };

  render() {
    const { groups, offer, staticPath } = this.props;
    const { names, sizes } = this.getFilterList(groups);
    const banners = this.getBannerFormat(groups, this.state.filter);

    return (
      <Card>
        <Card.Header>
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to="/offers/all">
                <FormattedMessage id="offers.breadcrumb" defaultMessage="All offers" />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <Link to={`/offers/${offer.id}`}>{offer.title}</Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <FormattedMessage id="offer.promo.breadcrumb" defaultMessage="Promo files" />
            </BreadcrumbItem>
          </Breadcrumb>
        </Card.Header>

        {offer.id && (
          <Fragment>
            <Card.Body>
              <PromoGroupFilter
                names={names}
                sizes={sizes}
                offerId={offer.id}
                types={this.getTypes()}
                onChange={this.handleFilterChange}
                shouldHideSelectors={!banners.length}
              />
            </Card.Body>

            <Card.Body className="no-padding" key={JSON.stringify(this.state.filter)}>
              {banners.length > 0 ? (
                <PromoGroup staticPath={staticPath} offerId={offer.id} banners={banners} />
              ) : (
                <div className="card-empty">
                  <FormattedMessage id="offer.promo.no-files" defaultMessage="No files" />
                </div>
              )}
            </Card.Body>
          </Fragment>
        )}
      </Card>
    );
  }
}

const mapStateToProps = ({ offers, app }) => ({
  groups: offers.extra.groups,
  offer: offers.selected,
  staticPath: app.globalSettings.staticPath,
});

const mapDispatchToProps = dispatch => ({
  startSetOffer: offerId => dispatch(startSetOffer(offerId)),
  startSetOfferExtraGroups: offerId => dispatch(startSetOfferExtraGroups(offerId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OfferPromo);
